/* unplugin-vue-components disabled */import { render } from "./WalkthroughPointer.vue?vue&type=template&id=5bc5e8fb&scoped=true"
import script from "./WalkthroughPointer.vue?vue&type=script&lang=js"
export * from "./WalkthroughPointer.vue?vue&type=script&lang=js"

import "./WalkthroughPointer.vue?vue&type=style&index=0&id=5bc5e8fb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc5e8fb"]])

export default __exports__